import { render, staticRenderFns } from "./DesignContent4.vue?vue&type=template&id=e0b4325e&"
import script from "./DesignContent4.vue?vue&type=script&lang=ts&"
export * from "./DesignContent4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports